module.exports = __webpack_public_path__ + "img/var_02_dec.1f895601.png";